import React, { useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { DropzoneAreaBase, FileObject } from 'material-ui-dropzone';
import { unionWith } from 'lodash';
import { useStyles } from './styles';
import ImageViewer from '../ImageViewer';
import ImageThumbnail from './ImageThumbnail';

const FILE_LIMIT_COUNT = 15;
const FILE_LIMIT_SIZE = 15000000000; // 150mb
interface IProps {
  files: FileObject[];
  setFiles: React.Dispatch<React.SetStateAction<FileObject[]>>;
  fileDescriptions: string[];
  setFileDescription: React.Dispatch<React.SetStateAction<string[]>>;
}

const FileAttachmentFormGroup: React.FC<IProps> = ({
  files,
  setFiles,
  fileDescriptions,
  setFileDescription,
}) => {
  const classes = useStyles();
  const [expandedImg, setExpandedImg] = useState<{ data: string; name?: string }>({
    data: '',
    name: '',
  });
  const [openImg, setOpenImg] = useState<boolean>(false);

  const addFile = (fileObjects: FileObject[]) => {
    if (files.length === 0) {
      setFiles(fileObjects);
      setFileDescription(fileObjects.map(() => ''));
      return;
    }

    const imgs = unionWith(files, fileObjects, (a, b) => a.file.name === b.file.name);
    setFiles(imgs);
  };

  const deleteFile = (deletedFileObj: FileObject, index: number) => {
    const imgs = files.filter((img) => img.file.name !== deletedFileObj.file.name);
    fileDescriptions.splice(index, 1)
    setFiles(imgs);
    setFileDescription(fileDescriptions);
  };

  const getFileAddedMessage = (fileName: string) => {
    return `${fileName} adicionado.`;
  };

  const getFileRemovedMessage = (fileName: string) => {
    return `${fileName} removido.`;
  };
  const getFileLimitExceedMessage = (fileLimit: number) => {
    return `Limite de arquivos atingidos. O máximo é ${fileLimit}.`;
  };

  const expandImg = (imgSrc: string, imgName: string) => {
    setExpandedImg({ data: imgSrc, name: imgName });
  };

  return (
    <Accordion className={classes.accordionContainer}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Anexos</Typography>
      </AccordionSummary>
      <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>
        <Container className={classes.addButtonContainer}>
          <Typography variant="subtitle1" className={classes.subtitle}>
            {files.length} de {FILE_LIMIT_COUNT} imagens adicionadas
          </Typography>

          <DropzoneAreaBase
            dropzoneText="Arraste os arquivos ou clique para adicionar"
            filesLimit={FILE_LIMIT_COUNT}
            maxFileSize={FILE_LIMIT_SIZE}
            onAdd={addFile}
            fileObjects={files}
            acceptedFiles={['image/*']}
            getFileAddedMessage={getFileAddedMessage}
            getFileRemovedMessage={getFileRemovedMessage}
            getFileLimitExceedMessage={getFileLimitExceedMessage}
            showPreviewsInDropzone={false}
            showPreviews={false}
            dropzoneClass={classes.filePreview}
          />
          {files.map((file, index) => {
            return (
              <ImageThumbnail
                file={file}
                index={index}
                deleteFile={deleteFile}
                expandImg={expandImg}
                setOpenImg={setOpenImg}
                description={fileDescriptions[index]}
                setDescription={setFileDescription}
              />
            );
          })}
        </Container>
        {expandedImg && (
          <ImageViewer
            open={openImg}
            setOpen={setOpenImg}
            data={expandedImg.data}
            name={expandedImg.name || "Imagem em anexo"}
          />
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default FileAttachmentFormGroup;
